export default __webpack_public_path__ + "static/media/documents.9d658609.jpg";